module.exports = __webpack_public_path__ + "static/media/es.15674bd9.svg";